import Term from "./Term";
import { sourceStatusTerm } from "./glossary";
import { cn } from "@/lib/utils";
import type { ProgramSourceCounts, ProgramSourceStatus } from "@/services/adminProgramNews";

export type SourceFilter = ProgramSourceStatus | "all";

interface SourceStatusCountsProps {
  counts: ProgramSourceCounts;
  active: SourceFilter;
  onChange: (filter: SourceFilter) => void;
}

const TILES: Array<{ key: SourceFilter; label: string; accent: string }> = [
  { key: "all", label: "All", accent: "text-foreground" },
  { key: "verified", label: "Verified", accent: "text-green-700" },
  { key: "queued", label: "Queued", accent: "text-amber-700" },
  { key: "failed", label: "Failed", accent: "text-red-700" },
  { key: "disabled", label: "Disabled", accent: "text-muted-foreground" },
  { key: "override_stale", label: "Override stale", accent: "text-orange-700" },
];

function countFor(counts: ProgramSourceCounts, key: SourceFilter): number {
  if (key === "all") {
    return (
      counts.verified +
      counts.queued +
      counts.failed +
      counts.disabled +
      (counts.override_stale ?? 0)
    );
  }
  return counts[key] ?? 0;
}

const SourceStatusCounts = ({ counts, active, onChange }: SourceStatusCountsProps) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      {TILES.map(({ key, label, accent }) => {
        const isActive = active === key;
        return (
          <button
            key={key}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(key)}
            className={cn(
              "rounded-lg border p-3 text-left transition-colors hover:bg-muted/50",
              isActive ? "border-primary bg-muted ring-2 ring-primary" : "border-border"
            )}
          >
            <div className="text-sm text-muted-foreground">
              {key === "all" ? label : <Term term={sourceStatusTerm(key)}>{label}</Term>}
            </div>
            <div className={cn("text-2xl font-semibold", accent)}>{countFor(counts, key)}</div>
          </button>
        );
      })}
    </div>
  );
};

export default SourceStatusCounts;
